import XAPPService from 'app/Core/services/XAPPService';
export const GET_FILTER = '[FILTER APP] GET FILTER';
export const NEW_FILTER = '[FILTER APP] NEW FILTER';
export const SAVE_FILTER = '[FILTER APP] SAVE FILTER';
export const ERROR_FILTER = '[FILTER APP] ERROR FILTER';
export const TOGGLE_PAINEL = '[FILTERPAINEL] TOGGLE PAINEL';

const FilterListState =
    [
        'campo',
        'tipo',
        'valor',
    ];

export function list(_AAction, _AParams, _ATarget) {

    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];
        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "Pessoa", AActions, "spvwpessoa", FilterListState, _AAction, AConditionsAND, AConditionsOR)

        XAPPService.XappSelAction(AActions, _AParams)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_FILTER,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data[0] : "",
                    })
                ])
            );
    };
}

export function save(_AFilter) {
    return (dispatch) => {
        Promise.all([
            dispatch({
                type: SAVE_FILTER,
                payload: _AFilter,
            })
        ])
            .catch(error => {
                return dispatch({
                    type: ERROR_FILTER,
                    payload: error
                });
            });
    };
}

export function togglePainel() {
    return {
        type: TOGGLE_PAINEL
    }
}